export enum ObligationTypeEnum {
  SalesContractLiability = 'SalesContractLiability',
  GratuitousTransferContractLiability = 'GratuitousTransferContractLiability',
  NonGratuitousTransferContractLiability = 'NonGratuitousTransferContractLiability',
  RentalContractShorterThan1YearLiability = 'RentalContractShorterThan1YearLiability',
  RentalContractLongerThan1YearLiability = 'RentalContractLongerThan1YearLiability',
  RentalContractCommonLiability = 'RentalContractCommonLiability',
  GiftContractLiability = 'GiftContractLiability',
  FulfillmentOfDecisionAuctionSaleExecutionLiability = 'FulfillmentOfDecisionAuctionSaleExecutionLiability',
  RealBurdenLiability = 'RealBurdenLiability',
  RealBurdenLiabilityAccelerated = 'RealBurdenLiabilityAccelerated',
  FutureRealBurdenLiabilityAccelerated = 'FutureRealBurdenLiabilityAccelerated',
  FulfillmentOfDecisionExpropriationLiability = 'FulfillmentOfDecisionExpropriationLiability',
  RightToRealizeABuildingLiability = 'RightToRealizeABuildingLiability',
  AgreementOnAOtherFutureContractLiability = 'AgreementOnAOtherFutureContractLiability',
  AgreementOnAFutureTransferContractLiability = 'AgreementOnAFutureTransferContractLiability',
  AgreementOnAFutureNetworkConstructionContractLiability = 'AgreementOnAFutureNetworkConstructionContractLiability',
  InnominateSalesContractLiability = 'InnominateSalesContractLiability',
  AccessToLandLiability = 'AccessToLandLiability',
  BuildingPlacementLiability = 'BuildingPlacementLiability',
  OwnersStatementLiability = 'OwnersStatementLiability',
  ExchangeContractLiability = 'ExchangeContractLiability',
  TemporaryExpropriationLiability = 'TemporaryExpropriationLiability',
  BorrowingLiability = 'BorrowingLiability',
  OtherLiability = 'OtherLiability',
}
